import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components.
import Option from '../Option';

//------------------------------------------------------------------------------

const Options = ({ className, active, options, selected, onClickOption }) => {
  const classNameRoot = classNames(
    'Options',
    { 'Options--active': active },
    className,
  );
  return (
    <div className={classNameRoot}>
      {options.map(({ uid, content }) =>
        <Option
          key={uid}
          active={uid === selected}
          tabIndex={active ? null : '-1'}
          onClick={event => onClickOption(event, uid, content)}
        >
          {content}
        </Option>,
      )}
    </div>
  );
};

Options.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      uid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      content: PropTypes.node,
    }),
  ).isRequired,
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClickOption: PropTypes.func.isRequired,
};

Options.defaultProps = {
  className: null,
  active: false,
  selected: null,
};

export default Options;



// WEBPACK FOOTER //
// ./src/components/Form/Field/Select/Options/index.js